import { ErrorAPI } from 'api/Associado/methods';
import ErrorHandler from 'utils/ErrorHandler';
import { AxiosError } from 'axios';
import { getToastError } from './ToasterUtils';

export const getAxiosError = (error: AxiosError): string | null => {
  if (error.response && error.response.data) {
    if (Array.isArray(error.response.data.details) && error.response.data.details.length > 0) {
      return error.response.data.details[0].message as string;
    } else {
      return error.response.data.message as string;
    }
  } else {
    if (typeof error.message === 'string') {
      return error.message;
    }
  }
  return null;
}

export default function (error: AxiosError) {
  if (error.response && error.response.data) {
    ErrorHandler(error.response.data as ErrorAPI);
  } else {
    getToastError(error.message);
  }
}

export const getAxiosErrorApiCode = (error: AxiosError): string | number | null => {
  if (error.response && error.response.data) {
    const data: ErrorAPI = error.response.data;
    if (data.code) {
      return data.code;
    }
  }
  switch(typeof error.code) {
    case 'string':
    case 'number':
      return error.code;
    default:
      return null;
  }
}
